import script from "./notice.vue?vue&type=script&setup=true&lang=js"
export * from "./notice.vue?vue&type=script&setup=true&lang=js"

import "./notice.vue?vue&type=style&index=0&id=20416df7&lang=less&scoped=true"

import exportComponent from "/data/home/csserver/project/cpcps/h5fe_cpcps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20416df7"]])

export default __exports__